import { getFileUrl, getImage } from 'utils/helper';

export const useChallengesAndSolutionsWithWireframes = ({ data, type }) => {
  const {
    view,
    contentModules,
    images: rawImages,
    background,
  } = data;

  const images = (rawImages || []).map((rawImage) => getImage(rawImage));
  const backgroundImageUrl = getImage(background).url;

  return {
    data,
    type,
    view,
    firstBlock: contentModules?.[0]?.fields,
    secondBlock: contentModules?.[1]?.fields,
    images,
    backgroundImageUrl,
  };
};
